/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".view2dcontainer[_ngcontent-%COMP%]{width:100%;height:100%}view2d[_ngcontent-%COMP%]{width:100%;height:100%;overflow:hidden}.top-buttons[_ngcontent-%COMP%]{position:absolute;z-index:1000;top:104px;left:0}"];
export { styles as styles };
